import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { PageHeader, PageContent } from 'SRC/ui'
import { Package } from 'SRC/modules/users/Registration/components/Form/Content/Package'
import { fetchListings } from 'SRC/modules/ads/lisitings/actions'
import { getUserInfo, getProfileLoading } from '../../../selectors'
import { getSelectedPackage, getPackages } from 'SRC/modules/users/packages/selectors'
import { connect } from 'react-redux'
import { Preloader } from 'SRC/ui/Preloader'

const text1 = 'Paket možete promijeniti jednom u mjesecu. Promjena na paketu vam se računa od 1-og sledećeg mjeseca'
const text2 = 'Ukoliko želite da promijenite paket pozovite +382 67 733 941'

const PackageList = ({ listings, fetchListings, user, packageName, isLoading }) => {
  const { t } = useTranslation('common')

  useEffect(() => {
    if (!listings || !listings.length) fetchListings()
  }, [])

  return (
    <React.Fragment>
      <PageHeader key='header'>{t('Korisnički profil')}</PageHeader>
      <PageContent key='content'>
        <div className='registracija-content-heading'>
          <h1 className='heading'>{`${t('Izabrani paket')} ${packageName ? `- ${packageName}` : ``}`}</h1>
          <p>{t('profile_packages_text_1')}</p>
          <strong>{t('profile_packages_text_2')}</strong>
        </div>
        <Package currentUserType={user && user.type} page='profile' />
        {isLoading ? <Preloader /> : null}
      </PageContent>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  let packageName = null
  const selectedPackageId = getSelectedPackage(state)
  const packages = getPackages(state)
  if (Array.isArray(packages) && packages.length && selectedPackageId) {
    const filteredPackage = packages.filter(item => item.id === selectedPackageId)
    if (filteredPackage.length) {
      packageName = filteredPackage[0].name
    }
  }
  return { user: getUserInfo(state), packageName, isLoading: getProfileLoading(state) }
}

PackageList.propTypes = {
  user: PropTypes.shape({
    type: PropTypes.shape().isRequired
  }).isRequired,
  packageName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  fetchListings: PropTypes.func.isRequired
}

PackageList.defaultProps = {
  isLoading: false
}

export default connect(mapStateToProps, { fetchListings })(PackageList)
